import { Invitation, Participant } from '../../invitations/models/invitation.model';
import { PoolRow } from '../../reports/services/report-pool';
import { SessionSource } from '../models/session.model';

/**
 * Every eligible participant across the chosen sources, where a source is a whole ORG or a single
 * INVITATION. An invitation is included if its rosterId is an org source OR its id is an invitation
 * source; since each invitation contributes at most once, a person cannot appear twice even when
 * both their org and their invitation are added — no de-duplication needed.
 *
 * `eligibleOf` is a PARAMETER: the eligibility rule (scored AND unlocked) is defined once in
 * InvitationMockService.eligibleParticipants and handed in. Re-deriving it here would fork it.
 */
export function composeSessionPool(
  invitations: Invitation[],
  sources: SessionSource[],
  eligibleOf: (inv: Invitation) => Participant[],
): PoolRow[] {
  const orgIds = new Set(sources.filter(s => s.kind === 'org').map(s => s.id));
  const invIds = new Set(sources.filter(s => s.kind === 'invitation').map(s => s.id));
  const rows: PoolRow[] = [];
  for (const inv of invitations) {
    if (!orgIds.has(inv.rosterId) && !invIds.has(inv.id)) { continue; }
    for (const participant of eligibleOf(inv)) {
      rows.push({
        participant,
        orgId: inv.rosterId, orgName: inv.rosterName,
        invitationId: inv.id, invitationName: inv.name,
      });
    }
  }
  return rows;
}
